import { Card, Col, Image, Row } from 'react-bootstrap';
import { CustomText } from 'components/CustomText';
import { CustomCombinedText } from 'components/CustomCombinedText';
import { formatCurrency } from 'helper/formatText';

const OrderItemsSection = ({ filteredData, isMobile, currencySymbol }) => {
  return (
    <>
      <Col md={12}>
        <Card className="border-0 mb-4 mb-lg-0 mb-md-0 mt-2">
          <Card.Header>
            <Row>
              <Col>
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={14}
                  fontWeight={400}
                  textStyle={{
                    textTransform: 'uppercase',
                  }}
                >
                  Items
                </CustomText>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="pt-lg-2">
            {filteredData?.map((item, index) => {
              return (
                <Card
                  key={item?.id}
                  style={{
                    minHeight: '100px',
                    paddingRight: '20px',
                    paddingLeft: '20px',
                    marginBottom: '10px',
                    paddingTop: isMobile ? 20 : 0,
                    paddingBottom: isMobile ? 20 : 0,
                  }}
                >
                  <Row>
                    <Col
                      lg="auto"
                      md="auto"
                      sm="auto"
                      className={isMobile ? 'centered' : ''}
                    >
                      <Image
                        src={item?.image}
                        alt=""
                        fluid
                        style={{ maxHeight: 100 }}
                      />
                    </Col>
                    <Col className="py-3 px-2 d-flex flex-column align-items-start justify-content-between">
                      <CustomText
                        fontFamily={'Poppins'}
                        fontSize={14}
                        fontWeight={600}
                        text={item?.name}
                        // cNColor="gray"
                        // textClassName="text-capitalize"
                      />
                      <CustomCombinedText
                        firstFontFamily={'Poppins'}
                        firstText="Price per Unit: "
                        firstFontSize={12}
                        secondFontFamily={'Poppins'}
                        secondFontSize={12}
                        secondText={` ${formatCurrency(
                          item?.price,
                          2,
                          currencySymbol
                        )?.replace('.00', '')}`}
                        // cNColor="gray"
                        // textClassName="text-capitalize"
                      />
                      <CustomCombinedText
                        firstFontFamily={'Poppins'}
                        firstText="Quantity:"
                        firstFontSize={12}
                        secondFontFamily={'Poppins'}
                        secondFontSize={12}
                        secondText={` ${item?.quantity} (${item?.uom})`}
                        // cNColor="gray"
                        // textClassName="text-capitalize"
                      />
                    </Col>
                    <Col
                      lg="auto"
                      md="auto"
                      sm="auto"
                      className="mt-lg-3 mt-md-3 mt-sm-0 align-items-end"
                    >
                      <CustomText
                        fontFamily={'Poppins'}
                        fontSize={!isMobile ? 16 : 14}
                        fontWeight={600}
                        text={formatCurrency(
                          item?.quantity * item?.price,
                          2,
                          currencySymbol
                        )?.replace('.00', '')}
                        textStyle={{ textAlign: 'right' }}
                      />
                    </Col>
                  </Row>
                </Card>
              );
            })}
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default OrderItemsSection;
